import './home.css';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import WeeklyPointsArchive from "../components/WeeklyPointsArchive";

export default function WeeklyPointsArchivePage() {
  const { user } = useContext(UserContext);
  return (
    <div style={{width:'100vw', margin:0, padding:0, display:'flex', justifyContent:'center'}}>
      <div className="home-page" style={{padding:32, maxWidth:800, width:'100%'}}>
        {/* Hero */}
        <section
          id="top"
          className={user ? 'hero-offset-if-sidebar' : ''}
          style={{
            width: '100vw',
            marginTop: 0,
            marginBottom: 0,
            padding: 0,
            marginLeft: 'calc(50% - 50vw)',
            marginRight: 'calc(50% - 50vw)',
          }}
        >
          <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Wochen‑Archiv</h2>
          <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Vergangene Wochenpunkte – nutze das Archiv zum Vergleich der Entwicklung und Trends über die Zeit.</p>
        </section>
        <WeeklyPointsArchive />
      </div>
    </div>
  );
}
